<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-shield"></i> Usuários</h3>
      </div>
    </div>
    <AccountAdd v-if="showAdd" ref="AccountAdd" v-on:Back="onBack" />
    <AccountList v-else ref="AccountList" v-on:New="onNewAccount" v-on:Edit="onEditAccount"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import AccountAdd from './components/add/accountadd.vue'
import AccountList from './components/list/accountlist.vue'

export default {
  name: 'Account',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    AccountAdd,
    AccountList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onNewAccount () {
      this.showAdd = true
    },
    onEditAccount (account) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.AccountAdd.onEdit(account)
      })
    },
    onBack () {
      this.showAdd = false
    },
    onLoad () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/account/account.vue